import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../config');
var report = require('../../generics/report_head');

class MadeAliquots extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.checking = this.checking.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.setTable = this.setTable.bind(this);

		this.state = {
			health_facilities_id:"",
			health_facilities: [],

			start_date 	:"",
			end_date 	:"",
			start_folio:"",
			end_folio:"",
			search_type:"date",

			components:[],
			component_type:"all",
			component_name:"",

			listado:[],

			change_check: false,
			columns:[
				{title:'COMPONENTE'},
				{title:'No. UNIDAD'},
				
			],
			totales:"0",
			date_hour:"",
			medical:"",
			date_hour:"",
			medical:"",
			total_obtenido:"0",
			format:"detail",
			total_components:[]
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');

		fetch(Config.default.apiGateway.URL+'health_facilities', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities: response
				});
			}
		});


		fetch(Config.default.apiGateway.URL+'lookups?type=blood_component_type&option=actives&order=false', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					components: response
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){
		var fechas = this.state.search_type === 'date' ?
			"Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
			" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 
		: ""
		this.$el = $(this.el);

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: "Alicuotas Realizadas"
            	},
            	{
                	extend: 'pdfHtml5',
                	title: "Alicuotas Realizadas",
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });

						if(this.state.format === 'detail'){
							var head = []
							this.state.columns.map((c, i)=>{
								if(i > 0){
									head.push({text:c.title, style:'tableHeader'})
								}
								
							})

							this.state.listado_pdf.unshift(head);
							
							doc.content.splice(3, 0, {
								columns:[
									this.state.component_type !== "all" ?
										{text: 'Tipo Componente', width:'12%', fontSize:6.5}
									: {text:"", width:0},
									this.state.component_type !== "all" ?
										{text: this.state.component_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
									: {text:"", width:0},
								]
							});
							doc.content[4].table.body = this.state.listado_pdf;
							doc.content[5] = {
								text:'Unidades Procesadas '+this.state.totales,
								margin:[5,15,0,0]
							}
							doc.content[6] = {
								text:'Unidades Obtenidas '+this.state.total_obtenido,
								margin:[5,15,0,0]
							}
						}else{
							doc.content.splice(3, 0, {text: 'Número de unidades : '+this.state.totales, margin:[10,0,0,10] });
							doc.content[4].table.widths = ['10%', '25%','10%','10%','10%','10%','10%','15%'];

							var components = '';
							this.state.total_components.map((t)=>{
								components += t.code+': '+t.total+' ';
							})
							doc.content.push({text: components, margin:[5,15,0,0]})
						}
						
                		doc.defaultStyle.fontSize = 6.5;
                		doc.styles.tableHeader.fontSize = 6.5;

                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	},
            ],
            rowGroup: {
	            dataSrc: this.state.format === 'detail' ? [ 0 ] : [],
	            startRender:  ( rows, group )=>{
					var len = rows.data()[0].length-1;
					if(this.state.format === 'detail'){
						return $('<tr/>')
	                    	.append( '<td colspan="'+len+'">'+group+'</td>' );
					}
	            	
	            },
	        },
	        columnDefs: [ {
	            targets: [ 0 ],
	            visible: this.state.format === 'detail' ? false : true
	        } ],
			data: this.state.listado,
			columns:this.state.columns,
			
			oLanguage:{
				"sProcessing":"Procesando...",
				"sLengthMenu":"Mostrar _MENU_ registros",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfo":"Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered":"(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"oPaginate":{
					"sFirst":"Primero",
					"sLast":"Último",
					"sNext":"Siguiente",
					"sPrevious":"Anterior"},
					"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
			createdRow: (row, data, dataIndex)=>{
				if(typeof data[data.length - 1] === 'number' && this.state.format === 'detail'){
					$(row).css('display', 'none');
				}
            }
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}

		console.log(this.state)
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		var control = document.getElementById(e.target.name);
		
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}

		if(e.target.name === 'search_type'){
			this.setState({
				start_date 	: "",
				end_date 	: "",
				start_folio:"",
				end_folio:"",
			})
		}else if(e.target.name === 'component_type'){
			this.setState({
				component_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'format'){
			if(e.target.value === 'group'){
				this.setState({
					columns:[
						{title:'Fecha'},
						{title:'Usuario'},
						{title:'Modificado'},
						{title:'Unidad'},
						{title:'Grupo'},
						{title:'Obtenido'},
						{title:'Alicuotas'},
						{title:'Caducidad'}
					],
					total_components:[]
				});
			}else{
				this.setState({
					columns:[
						{title:'COMPONENTE'},
						{title:'No. UNIDAD'},
						
					]
				})
			}
		}
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
					start_date:this.state.start_date,
					end_date:this.state.end_date,
					start_folio: this.state.start_folio,
					end_folio: this.state.end_folio,
					component_type: this.state.component_type, 
					health_facilities_id:this.state.health_facilities_id,
					format:this.state.format
				};
				
				this.props.waiting.handleShow('Buscando...');
				fetch(Config.default.apiGateway.URL+'reports/alicuot_process',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){

						this.setState({
							listado: [],
							totales:[]
						});

						var list = [], list_pdf = [];
						if(this.state.format === 'detail'){
							this.setState({
								columns:[{title:'COMPONENTE'},{title:'No. UNIDAD'}, {title:'USUARIO'}]
							});

							var mayor = 0;
							response.res.map((res)=>{
								res.units.map((u)=>{
									if(u.parts.length > mayor){
										mayor = u.parts.length
									}
								})
							});

							for(var i = 0; i < mayor; i++){
								this.state.columns.push({title:'No. Comp('+(i+1)+')'},{title:'Vol. Comp('+(i+1)+')'})
							}
							this.forceUpdate();
							
							
							response.res.map((r)=>{
								var obj = [], obj_pdf = [];

								obj.push(r.component);
								obj_pdf.push({text:r.component,colSpan:this.state.columns.length-2,bold:1,fillColor:'#dfdfdf'},{})
								for(var i = 0; i < mayor; i++){
									if(i === mayor - 1){
										obj.push('');
									}else{
										obj.push('','');	
									}
									
									if(i>0)
										obj_pdf.push({},{})
								}
								
								obj.push('','', r.total_parts);
								obj_pdf.push({},{text:'TOTAL: '+r.total,bold:1,fillColor:'#dfdfdf', alignment:'center'})
								
								list.push(obj);
								list_pdf.push(obj_pdf);
								
								r.units.map((u)=>{
									obj = [];
									obj_pdf = [];

									obj.push(u.component, u.unit_number, u.user);
									obj_pdf.push({text:u.unit_number},{text:u.user});

									u.parts.map((p)=>{
										obj.push(p.fraction_number, p.volume+' ml')
										obj_pdf.push({text:p.fraction_number, alignment:'center'}, {text:p.volume+' ml', alignment:'center'})
									})

									for(var i = u.parts.length; i < mayor; i++){
										obj.push('','');
										obj_pdf.push({},{});
									}

									list.push(obj);
									list_pdf.push(obj_pdf)
								})

							})
						}else{
							response.res.map((res, i)=>{
								list.push([
									moment(res.date).format('DD/MM/YYYY'),
									res.user,
									res.origin_component,
									res.unit_number,
									res.g_rh,
									res.obteained_component,
									res.total_parts,
									moment(res.expitration).format('DD/MM/YYYY HH:mm')
								])
							})
						}


						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);

						this.setState({
							listado: list,
							listado_pdf: list_pdf,
							totales:response.total,
							total_obtenido:response.total_obtained,
							total_components:response.totals
						});
						
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false,
				health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			});
		}else{
			this.setState({
				change_check: true,
			});
		}
	}


	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Procesado ->
					{t('sidebar.nav.reports.made_aliquots')}
					</h5>
				</div>
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Centro</span>
									<select type="text" name="health_facilities_id" id="health_facilities_id" 
										value={this.state.health_facilities_id} disabled={!this.state.change_check} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.health_facilities.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.name}
											</option>
										})}
									</select>

									<input type="checkbox" name="change_center" id="change_center" 
										style={{marginRight:"5px"}} onChange={this.checking}
										checked={this.state.change_check} />
									<span className="span-min">Cambiar</span>
								</div>

								<div className="form-group">
									<span className="span-min">Formato</span>
									<select className="form-control" name="format" id="format" value={this.state.format} onChange={this.handleChange} required>
										<option value="detail">Detallado</option>
										<option value="group">Agrupado</option>
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Tipo de Busqueda</span>
									<select className="form-control" name="search_type" id="search_type"
										value={this.state.search_type} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="date">Fecha</option>
										<option value="folio">Folio</option>
									</select>
								</div>

								{this.state.search_type === 'date' ?
									<div>
										<div className="form-group">
											<span className="span-min">Fecha Desde</span>
											<input type="date" className="form-control hour-input" name="start_date" id="start_date"
												value={this.state.start_date} onChange={this.handleChange} required />
										</div>
										<div className="form-group">
											<span className="span-min">Fecha Hasta</span>
											<input type="date" className="form-control hour-input" name="end_date" id="end_date"
												value={this.state.end_date} onChange={this.handleChange} required />
										</div>
									</div>
								: <div className="form-group">
									<div className="col-xs-12 col-sm-6 form-group" style={{paddingLeft:"0"}}>
										<span className="span-min">Folio Desde</span>
										<input type="text" className="form-control"  name="start_folio" id="start_folio"
											value={this.state.start_folio} onChange={this.handleChange} />
									</div>
									<div className="col-xs-12 col-sm-6 form-group" style={{paddingRight:"0"}}>
										<span className="span-min">Folio Hasta</span>
										<input type="text" className="form-control" name="end_folio" id="end_folio"
											value={this.state.end_folio} onChange={this.handleChange} />
									</div>
								</div>
								}

								<div className="form-group">
									<span className="span-min">Tipo Componente</span>
									<select className="form-control"  name="component_type" id="component_type"
										value={this.state.component_type} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.components.map((c, i)=>{
											return <option key={i} value={c.key}>
												{c.name}
											</option>
										})}
									</select>
								</div>
								
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} 
										style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline", fontSize:'16px'}}>
										<span>
											{t('sidebar.nav.reports.made_aliquots')}
										</span>
									</div>
									{this.state.search_type === 'date' ?
										<div className="col-xs-12" >
											<span>
												Información Del:  {this.state.start_date !== "" ?
													moment(this.state.start_date).format("DD/MM/YYYY")
												: ''}    
											</span>
											<span style={{marginLeft:"5px"}}>	
												Al: {this.state.end_date !== "" ?
													moment(this.state.end_date).format("DD/MM/YYYY")
												: ''}
											</span>
										</div>
									: null}

									<div className="col-xs-12">
										{this.state.component_type !== 'all' && this.state.component_type !== ""?
											<span>
												Tipo Componente:  
												<b style={{marginLeft:"5px"}}>{this.state.component_name}</b>
											</span>	
										:null}
										{this.state.format === 'group' &&
											<span>
												Número de unidades: 
												<b style={{marginLeft:5}}>{this.state.totales}</b>
											</span>
											
										}
									</div>
									
								</div>

								<div className="col-xs-12 form-group" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} id="table-to-xls" width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>
								{this.state.format === 'detail' ?
									<div>
										<div className="col-xs-12" style={{fontSize:"14px"}}>
											<label style={{margin:"0 5px"}}>Unidades Procesadas:</label>{' '+this.state.totales || '0'}
										</div>
										<div className="col-xs-12 form-group" style={{fontSize:"14px"}}>
											<label style={{margin:"0 5px"}}>Unidades Obtenidas:</label>{' '+this.state.total_obtenido || '0'}
										</div>
									</div>
								: <div>
									{this.state.total_components.map((t, i)=>
										<span key={i}>
											{t.code+': '}
											<b>{t.total}</b>
										</span>
									)}
								</div>}
								
							</div>
						</form>
					</div>
				</div>

			</div>
		)
	}
}

export default translate('translations') (MadeAliquots);